import { IMarque } from './Marque.model';
import { ICategorie } from "./Categorie.model";
import { IStock } from "./Stock.model";
export interface IProduit {
  id?: number;
  code?: any;
  description?: any;
  etat?: any;
  image?: any;
  libelle?: any;
  quantite?: any;
  promo?: any;
  prixpromo?: any;
  prixUnitaire?: any;
  images?: any;
  categorie?: ICategorie;
  marque?: IMarque;
  stock?: IStock[];
}
export class Produit implements IProduit {
  constructor(
    public id?: number,
    public code?: any,
    public description?: any,
    public etat?: any,
    public image?: any,
    public libelle?: any,
    public quantite?: any,
    public promo?: any,
    public prixpromo?: any,
    public prixUnitaire?: any,
    public images?: any,
    public categorie?: ICategorie,
    public marque?: IMarque,
    public stocks?: IStock[]
  ) {}
}
